export function tripleClickEvent(el, cb, delay = 2000) {
    let clicksCount = 0;
    let clickTimer;
    function handleTripleClick() {
        clicksCount++;
        if (clicksCount === 1) {
            clickTimer = setTimeout(() => {
                clicksCount = 0;
            }, delay);
        }
        else if (clicksCount >= 3) {
            clearTimeout(clickTimer);
            clicksCount = 0;
            cb();
        }
    }
    el.addEventListener('click', handleTripleClick);
    return () => {
        el.removeEventListener('click', handleTripleClick);
    };
}
//# sourceMappingURL=tripple-click.js.map